import React from "react";
import { useNavigate } from "react-router-dom";

const NAVY = "#1A3B6E";

const styles = {
  bar: {
    backgroundColor: NAVY,
    color: "#fff",
    padding: "10px 16px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    zIndex: 1000,
    boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
    minHeight: "44px",
    boxSizing: "border-box",
  },
  spacer: {
    height: "54px",
  },
  title: {
    fontSize: "15px",
    fontWeight: "700",
    margin: 0,
    color: "#fff",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    marginRight: "12px",
  },
  homeBtn: {
    background: "rgba(255,255,255,0.12)",
    border: "1px solid rgba(255,255,255,0.3)",
    color: "#fff",
    borderRadius: "8px",
    padding: "8px 14px",
    fontSize: "13px",
    fontWeight: "600",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    gap: "6px",
    minHeight: "36px",
    minWidth: "44px",
    flexShrink: 0,
    WebkitTapHighlightColor: "transparent",
  },
};

export default function NavBar({ title }) {
  const navigate = useNavigate();
  return (
    <>
      <div style={styles.bar}>
        <h1 style={styles.title}>{title}</h1>
        <button style={styles.homeBtn} onClick={() => navigate("/")}>
          🏠 Home
        </button>
      </div>
      <div style={styles.spacer} />
    </>
  );
}
